// extracted by mini-css-extract-plugin
export default {"container":"ImageModal_container__9P1DF"};